import { get } from "../common/network";

export const fetchUsageReport = async () => {
    try {
        const data = await get("docgen/analytics");
        return data;
    } catch (err) {
        throw err;
    }
};
